import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CorsoModulo } from '../../../model/corsomodulo';
import { EsercitazioneService } from '../../../service/esercitazione.service';
import { ModuloService } from 'src/app/service/modulo.service';
import { UserEsercitazione } from 'src/app/model/esercitazione/useresercitazione';
import { Corso } from 'src/app/model/corso';
import { CourseService } from 'src/app/service/course.service';
import { Constants } from 'src/app/model/constants';

@Component({
  selector: 'app-esercitazione',
  templateUrl: './esercitazione.component.html',
  styleUrls: ['./esercitazione.component.css']
})
export class EsercitazioneComponent implements OnInit {

    moduloId: number;
    corso: Corso;
    modulo: CorsoModulo;
    moduloParentsStruct: Array<CorsoModulo>;
    esercitazione: UserEsercitazione;
    currentQuestion = 0;
    svolgimento: boolean;
    valutazione: boolean;
    loadingSpinner = false;

    constructor(
        private route: ActivatedRoute,
        private corsoSrv: CourseService,
        private moduloSrv: ModuloService,
        private esercitazioneSrv: EsercitazioneService
    ) { }

    ngOnInit() {
        this.esercitazione = null;
        this.route.paramMap.subscribe(params =>  {
            this.moduloId = +params.get('moduleId');
            const esercitazioneId = +params.get('esercitazioneId');
            this.loadCorso(+params.get('courseId'));
            this.loadModulo(this.moduloId);
            this.loadModuloParentsStruct(this.moduloId);
            if (esercitazioneId) {
                this.loadEsercitazione(esercitazioneId);
            } else {
                this.buildNewEsercitazione();
            }
        });
    }

    buildNewEsercitazione() {
        this.loadingSpinner = true;
        this.esercitazione = null;
        this.svolgimento = true;
        this.valutazione = false;
        this.esercitazioneSrv.buildEsercitazione(this.moduloId)
        .pipe(first())
        .subscribe(
            data => {
                this.esercitazione = data;
                this.loadingSpinner = false;
            },
            error => {
                return;
            }
        );
    }

    loadEsercitazione(esercitazioneId: number) {
        this.esercitazioneSrv.loadEsercitazione(esercitazioneId)
        .pipe(first())
        .subscribe(
            data => {
                this.svolgimento = false;
                this.valutazione = true;
                this.esercitazione = data;
            },
            error => {
                return;
            }
        );
    }

    evaluateEsercitazione(esercitazione: UserEsercitazione) {
        this.loadingSpinner = true;
        this.esercitazioneSrv.evaluateEsercitazione(esercitazione)
        .pipe(first())
        .subscribe(
            data => {
                this.svolgimento = false;
                this.valutazione = true;
                this.esercitazione = data;
                this.loadingSpinner = false;
            },
            error => {
                return;
            }
        );
    }

    private loadCorso(courseId: number) {
        this.corsoSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModulo(moduloId: number) {
        this.moduloSrv.getModuloCertificazione(moduloId)
        .pipe(first())
        .subscribe(
            data => {
                this.modulo = data;
            },
            error => {
                return;
            }
        );
    }

    private loadModuloParentsStruct(moduloId: number) {
        this.moduloSrv.getModuleParentsStruct(moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduloParentsStruct = data;
                },
                error => {
                    return;
                }
            );
    }

    isTfaSimulator(): boolean {
        if (this.corso && this.corso.id) {
            return Constants.TFA_SOSTEGNO_CERTIFICAZIONE_IDS.includes(this.corso.id);
        }
        return false;
    }

}
